<template>
  <div
    id="confirmation"
    class="container-fluid">
    <div class="row border-bottom border-muted py-3">
      <div class="
        col
        d-flex
        flex-column
        flex-lg-row
        align-items-center
      ">
        <h3 class="mb-3 m-lg-0">
          Order Confirmation
        </h3>

        <div class="flex-fill d-xs-none d-lg-block text-center">
           Confirmation Code: {{confirmationCode}}
        </div>

        <div class="m-0 d-flex text-right">
          <div>
            <div>Total Cost:</div>
            <div class="mt-1">Total Paid:</div>
          </div>

          <div class="ml-2">
            <div>{{total | currency}}</div>
            <div class="mt-1">{{totalPaid | currency}}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-3">
      <div
        v-for="registration in confirmedRegistrations"
        :key="registration.id">
        <div class="d-flex flex-column flex-lg-row align-items-lg-center">
          <!-- Registrant & Event -->
          <RegistrantAndEvent
            class="flex-fill text-lg-left text-center"
            :registration="registration"
          />
          <!-- / Registrant & Event -->

          <!-- Payment Summary -->
          <div class="mt-3 mt-lg-0 text-right mx-auto">
            <PaymentSummary
              class="d-flex justify-content-center justify-content-lg-end"
              :registration="registration"
            />

            <div
              class="mt-3 text-center text-lg-left"
              v-if="registration.balance_due > 0 && registration.waitlist">
              *Balance due when moved to Active Roster
            </div>

            <div
              class="mt-3 text-center text-lg-left"
              v-if="registration.balance_due > 0 && !registration.waitlist">
              *Balance due prior to start of event
            </div>
          </div>
          <!-- / Payment Summary -->
        </div>
        <hr>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import AppMixin from '../services/mixin.app';

export default {
  name: 'confirmation',
  mixins: [
    AppMixin,
  ],
  data() {
    return {
      confirmedRegistrations: [],
    };
  },
  computed: {
    totalPaid() {
      let sum = 0;

      _.each(this.confirmedRegistrations, (r) => {
        sum += this.convertFloatDollarsToIntegerCents(r.total_collected);
      });

      return sum / 100;
    },
    total() {
      let sum = 0;

      _.each(this.confirmedRegistrations, (r) => {
        sum += this.convertFloatDollarsToIntegerCents(r.calc_amount_total);
      });

      return sum / 100;
    },
    confirmationCode() {
      return (this.confirmedRegistrations[0] || {}).short_id;
    },
  },
  created() {
    const initConfirmation = () => {
      const { uuid } = this.$route.params;
      const confirmedRegistrations = _.filter(
        this.closedRegistrations,
        { registration_session_uuid: uuid },
      );

      if (uuid && confirmedRegistrations.length > 0) {
        this.confirmedRegistrations = confirmedRegistrations;
      } else {
        this.$router.replace({ name: 'not-found' });
      }
    };

    this.initPromise.then(initConfirmation);
  },
};
</script>
